import {view} from '@sail/ui/deprecated';
import {
  Conversation,
  Action,
  StripeAssistantCommandResponse,
  InlineDataConversationMessage,
} from '@stripe-internal/conversations-client';
import {
  SearchFilterResults,
  StripeAssistantSearchFiltersResponse,
} from '../../StripeAssistant/SearchFilterResults';
import {useAnalytics} from '../../AnalyticsProvider';
import {useAssistantAnalyticsCall} from '../../StripeAssistant/analytics-utils';

export type Props = {
  conversation: Conversation;
  message: InlineDataConversationMessage;
  stripeAssistantResponse: StripeAssistantCommandResponse;
  requestAction: (action: Action) => void;
};

const responseType = (response: StripeAssistantCommandResponse): string => {
  if (response.result?.actions?.some((action) => !!action.searchFilter)) {
    return 'search_filter';
  }

  return 'unknown';
};

export const StripeAssistantRow = ({
  conversation,
  message,
  stripeAssistantResponse,
  requestAction,
}: Props) => {
  const analytics = useAnalytics();

  const rowType = responseType(stripeAssistantResponse);

  useAssistantAnalyticsCall(conversation, message, (query: string | null) => {
    analytics.action('ai_assistant_get_command_complete', {
      ai_assistant_question: query,
      ai_assistant_commanding_function_name:
        stripeAssistantResponse.function_name,
      ai_assistant_commanding_result_status:
        stripeAssistantResponse.result_status,
      ai_assistant_commanding_result_text: stripeAssistantResponse.result?.text,
      ai_assistant_commanding_existing_conversation_id: conversation.id,
    });
  });

  let component;
  switch (rowType) {
    case 'search_filter': {
      component = (
        <SearchFilterResults
          stripeAssistantResponse={
            stripeAssistantResponse as StripeAssistantSearchFiltersResponse
          }
          requestAction={(action: Action) => {
            analytics.action('ai_assistant_search_clicked', {
              ai_assistant_search_query: action.data?.query,
            });

            requestAction(action);
          }}
        />
      );
      break;
    }
    default: {
      component = <view.div>{stripeAssistantResponse.result?.text}</view.div>;
    }
  }
  return <view.div data-testid="stripe-assistant-row">{component}</view.div>;
};
